import { NgModule } from "@angular/core";

import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./services/auth.guard";
import { ContentLayoutComponent } from "./shared/layout-components/layout/content-layout/content-layout.component";
import { ErrorLayoutComponent } from "./shared/layout-components/layout/error-layout/error-layout.component";
import { SwitcherlayoutComponent } from "./shared/layout-components/layout/switcherlayout/switcherlayout.component";
import { custompage } from "./shared/routes/custom.routes";
import { content } from "./shared/routes/routes";
import { switchercontent } from "./shared/routes/switcher.routes";

const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  {
    path: "",
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: "",
    redirectTo: "/dashboard/sales-dashboard",
    pathMatch: "full",
  },
  // Vertical layout
  {
    path: "",
    component: ContentLayoutComponent,
    children: content,
  },
  {
    path: "",
    component: ErrorLayoutComponent,
    children: custompage,
  },
  {
    path: "",
    component: SwitcherlayoutComponent,
    children: switchercontent,
  },
  {
    path: "",
    loadChildren: () =>
      import("./shared/shared.module").then((m) => m.SharedModule),
  },
  {
    path: "",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./component/components/components.module").then(
        (m) => m.ComponentsModule
      ),
  },

 

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
